import { effect, inject, Injectable, signal } from '@angular/core';
import { DeviceDetector } from '@client-monorepo/common/utilities';
import { ActivatedRoute, Router } from '@angular/router';
import { RefreshNotifierService } from '@client-monorepo/common/network';
import { Subscription } from 'rxjs';
import { NgxBottomSheetService } from '@digipay/ngx-bottom-sheet';
import { WalkThroughService } from '@client-monorepo/shared/common/walk-through';
import {
  HOME_WALKTHROUGH_CONFIG,
  HUB_WALKTHROUGH_CONFIG,
  NAVIGATION_WALK_THROUGH_CONFIG,
  PROFILE_WALKTHROUGH_CONFIG,
  STORE_WALK_THROUGH_CONFIG,
  TRANSACTION_WALKTHROUGH_CONFIG,
} from '@client-monorepo/common/ui-components';

@Injectable({
  providedIn: 'root',
})
export class InitiatorService {
  initialized = signal(false);
  deviceDetectorService = inject(DeviceDetector);
  bottomSheetService = inject(NgxBottomSheetService);
  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);
  refreshNotifierService = inject(RefreshNotifierService);
  walkthroughService = inject(WalkThroughService);
  refreshNotifierSubscription!: Subscription;
  mainRoute = 'home';

  constructor() {
    effect(() => {
      if (this.initialized()) {
        this.manageWalkthrough();
      }
    });
  }

  initiate(): void {
    if (!this.checkShouldNavigateToCredit()) {
      this.subscribeOnRefresh();
    }
  }

  private checkShouldNavigateToCredit(): boolean {
    const rt = this.activatedRoute.snapshot.queryParams['rt'];
    if (rt) {
      this.router.navigateByUrl(decodeURIComponent(this.router.url.replace(this.mainRoute + '?rt=', '')));
      return true;
    } else {
      this.initialized.set(true);
      return false;
    }
  }

  subscribeOnRefresh(): void {
    this.refreshNotifierSubscription = this.refreshNotifierService.refreshNotifier
      .pipe((tf) => tf)
      .subscribe({
        next: () => {
          this.manageWalkthrough();
        },
      });
  }

  manageWalkthrough(): void {
    const walkthroughHasSeen = localStorage.getItem('walk-through-dpx');
    if (!this.deviceDetectorService.isAwfulDevice() && !walkthroughHasSeen) {
      const walkThroughConfigs = [
        NAVIGATION_WALK_THROUGH_CONFIG,
        HOME_WALKTHROUGH_CONFIG,
        HUB_WALKTHROUGH_CONFIG,
        STORE_WALK_THROUGH_CONFIG,
        TRANSACTION_WALKTHROUGH_CONFIG,
        PROFILE_WALKTHROUGH_CONFIG,
      ];
      this.walkthroughService.manageWalkThrough(walkThroughConfigs);
    }
  }
}
